<template>
  <div class="container-list">
    <!-- <ul class="tab-wrap" >
      <li
        :class="`tab-btn ${nowIndex == index && 'active'}`"
        @click="changeTab(index,tab)"
        v-for="(tab, index) in tabList"
      >
        {{tab.name }}
      </li>
    </ul> -->
    <div class="flex">
      <div style="width: 20%" v-show="!($store.state.user.userInfo.natureId == 2)">
        <unitList @select="getUnit" @getFirst="getOne" style="margin-top: 20px"></unitList>
      </div>
      <div class="flex1">
        <div class="common-page common-head flex flex1" style="margin: 0; justify-content: space-between">
          <div class="common-page common-head-title">
            <i class="icon-tr--detailed" style="padding-right: 5px"></i>
            巡查点管理
          </div>
          <div class="flex" v-show="tabList[nowIndex].id == 0">
            <div class="ml20" v-hasPermi="['safe:safeplaceList:query']" @click="showDia = true">
              <el-button icon="el-icon-search" type="primary">查询</el-button>
            </div>
            <router-link
              v-hasPermi="['safe:safeplaceList:add']"
              class="ml20"
              :to="{
                path: '/safe/safe-addpoint',
                query: { areaId: params.c_point_area_id || '', cnum: cpNum },
              }"
            >
              <el-button icon="el-icon-plus" type="primary">新增</el-button>
            </router-link>
          </div>

          <div class="flex" v-show="tabList[nowIndex].id == 1">
            <!-- <div class="ml20" v-hasPermi="['safe:safeplaceList:query']"  @click="showDia = true">
                <el-button icon="el-icon-search" type="primary">查询</el-button>
              </div> -->
            <router-link
              v-hasPermi="['wenwu:safeplaceList:add']"
              class="ml20"
              :to="{
                path: '/safe/safe-addwwpoint',
                query: { areaId: params1.areaId || '', cnum: cpNum },
              }"
            >
              <el-button icon="el-icon-plus" type="primary">新增</el-button>
            </router-link>
          </div>

          <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
        </div>
        <div class="common-page common-body">
          <div class="common-page common-tool-bar" style="justify-content: flex-end"></div>
          <div class="flex">
            <div class="choose" v-if="tabList[nowIndex].id == 0">
              <div
                class="mt10"
                style="
                  border-bottom: 1px solid #ccc;
                  padding-bottom: 10px;
                  font-weight: 900;
                "
              >
                巡查区域列表
              </div>
              <div style="height: 90%; overflow: auto">
                <!-- <div
									class="areaitem"
									:class="!params.c_point_area_id ? 'mark' : ''"
									@click="chooseArea({ x_company_id: '' })"
								>
									全部点位
								</div> -->
                <div class="areaitem" v-for="item in areaList" :class="params.c_point_area_id === item.x_company_id ? 'mark' : ''" @click="chooseArea(item)">
                  {{ item.x_company_area }}
                </div>
              </div>
            </div>

            <div class="choose" v-else>
              <div
                class="mt10"
                style="
                  border-bottom: 1px solid #ccc;
                  padding-bottom: 10px;
                  font-weight: 900;
                "
              >
                巡查区域列表
              </div>
              <div style="height: 90%; overflow: auto">
                <div class="areaitem" v-for="item in areaList" :class="params1.areaId === item.x_company_id ? 'mark' : ''" @click="chooseArea(item)">
                  {{ item.x_company_area }}
                </div>
              </div>
            </div>

            <div class="flex1" v-if="tabList[nowIndex].id == 0">
              <div class="common-page common-list" style="margin: 0">
                <el-table :data="list" class="">
                  <el-table-column prop="c_point_number" label="巡查点编号" align="center"></el-table-column>
                  <!-- <el-table-column
                prop="c_point_name"
                label="巡查点名称"
                align="center"
              ></el-table-column> -->
                  <el-table-column prop="c_point_addr" align="center" label="巡查点位置"></el-table-column>
                  <el-table-column prop="c_point_area" align="center" label="巡查区域"></el-table-column>
                  <!-- <el-table-column
            prop="m_rate"
            align="center"
            label="巡查频次"
          ></el-table-column> -->

                  <el-table-column prop="c_create_time" align="center" label="创建时间"></el-table-column>

                  <el-table-column prop="c_states" align="center" label="状态">
                    <template slot-scope="scope">
                      {{ $map.safeState[scope.row.c_states] }}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="200px" fixed="right">
                    <template slot-scope="scope">
                      <router-link
                        :to="{
                          path: '/safe/safe-addpoint',
                          query: {
                            id: scope.row.c_point_uuid,
                            cnum: cpNum,
                            areaId: params.c_point_area_id || '',
                          },
                        }"
                        v-hasPermi="['safe:safeplaceList:edit']"
                      >
                        <el-button size="mini" type="warning">编辑</el-button>
                      </router-link>
                      <el-popconfirm
                        v-if="scope.row.c_states == 1"
                        title="确定禁用单位记录吗？"
                        class="cursor"
                        v-hasPermi="['safe:safeplaceList:stop']"
                        @onConfirm="changeStatus(scope.row, 0)"
                        @confirm="changeStatus(scope.row, 0)"
                      >
                        <a slot="reference" class="red"><el-button size="mini" type="danger" plain>停用</el-button></a>
                      </el-popconfirm>
                      <el-popconfirm
                        v-if="scope.row.c_states == 0"
                        title="确定启用此单位吗？"
                        class="cursor"
                        v-hasPermi="['safe:safeplaceList:stop']"
                        @onConfirm="changeStatus(scope.row, 1)"
                        @confirm="changeStatus(scope.row, 1)"
                      >
                        <a slot="reference"><el-button type="primary" size="mini">开启</el-button></a>
                      </el-popconfirm>

                      <el-popconfirm
                        title="确定删除此单位吗？"
                        class="cursor"
                        @onConfirm="changeStatus(scope.row, 2)"
                        @confirm="changeStatus(scope.row, 2)"
                        v-hasPermi="['safe:safeplaceList:remove']"
                      >
                        <a slot="reference"><el-button type="danger" size="mini">删除</el-button></a>
                      </el-popconfirm>
                      <el-button type="info" icon="el-icon-view" size="mini" plain @click="makeerwei(scope.row)"></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <el-pagination background layout="prev, pager, next" @current-change="pageChange" :page-size="10" :total="total"></el-pagination>
            </div>
            <div class="flex1" v-else>
              <div class="common-page common-list" style="margin: 0">
                <el-table :data="list1" class="mt10">
                  <el-table-column prop="pointNum" label="巡查点编号" align="center"></el-table-column>
                  <!-- <el-table-column
                prop="c_point_name"
                label="巡查点名称"
                align="center"
              ></el-table-column> -->
                  <el-table-column prop="pointAddr" align="center" label="巡查点位置"></el-table-column>
                  <el-table-column prop="pointArea" align="center" label="巡查区域"></el-table-column>
                  <!-- <el-table-column
            prop="m_rate"
            align="center"
            label="巡查频次"
          ></el-table-column> -->

                  <el-table-column prop="createTime" align="center" label="创建时间"></el-table-column>

                  <el-table-column prop="states" align="center" label="状态">
                    <template slot-scope="scope">
                      {{ $map.safeState[scope.row.states] }}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="200px" fixed="right">
                    <template slot-scope="scope">
                      <router-link
                        :to="{
                          path: '/safe/safe-addwwpoint',
                          query: { id: scope.row.id, cnum: cpNum },
                        }"
                        v-hasPermi="['wenwu:safeplaceList:edit']"
                      >
                        <el-button size="mini" type="warning" plain>编辑</el-button>
                      </router-link>
                      <el-popconfirm
                        v-if="scope.row.states == 1"
                        title="确定禁用单位记录吗？"
                        class="cursor"
                        v-hasPermi="['wenwu:safeplaceList:stop']"
                        @onConfirm="changeStatus1(scope.row, 0)"
                        @confirm="changeStatus1(scope.row, 0)"
                      >
                        <a slot="reference" class="red"><el-button size="mini" type="danger" plain>停用</el-button></a>
                      </el-popconfirm>
                      <el-popconfirm
                        title="确定启用此单位吗？"
                        v-if="scope.row.states == 0"
                        v-hasPermi="['wenwu:safeplaceList:stop']"
                        class="cursor"
                        @onConfirm="changeStatus1(scope.row, 1)"
                        @confirm="changeStatus1(scope.row, 1)"
                      >
                        <a slot="reference"><el-button type="primary" size="mini" plain>开启</el-button></a>
                      </el-popconfirm>

                      <el-popconfirm
                        title="确定删除此单位吗？"
                        class="cursor"
                        @onConfirm="changeStatus1(scope.row, 2)"
                        @confirm="changeStatus1(scope.row, 2)"
                        v-hasPermi="['wenwu:safeplaceList:remove']"
                      >
                        <a slot="reference"><el-button type="danger" size="mini">删除</el-button></a>
                      </el-popconfirm>
                      <el-button type="info" icon="el-icon-view" size="mini" plain @click="makeerwei(scope.row)"></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- <el-pagination background layout="prev, pager, next" @current-change="pageChange" :page-size="10" :total="total1"></el-pagination> -->
              <el-pagination
                class="pagination"
                background
                layout="prev, pager, next"
                :current-page.sync="params1.pageNum"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="10"
                :page-size.sync="params1.pageSize"
                :total="total"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
      <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"></fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="cancle" size="small">重置</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showDia1" width="50%" :close-on-click-modal="false">
      <div ref="imageWrapper" id="imageWrapper" class="flex1" style="padding: 10px 20px 20px">
        <div
          class="er_title flex1 center"
          style="
            font-size: 30px;
            font-weight: 900;
            border-bottom: 1px solid #000;
            padding: 10px 0;
          "
        >
          {{ $store.state.user.company.cName }}
        </div>
        <div class="flex mt20 center" style="padding-right: 15px">
          <el-form v-if="tabList[nowIndex].id == 0" v-model="erform" style="min-width: 55%">
            <el-form-item prop="area" label-width="10px" label="">
              <!-- <div slot="label" style="font-size:24px">编号:</div> -->
              <div style="font-size: 22px">
                {{ '编号: ' + erform.c_point_number }}
              </div>
            </el-form-item>
            <el-form-item prop="area" label-width="10px">
              <!-- <div slot="label" style="font-size:24px">名称:</div> -->

              <div style="font-size: 22px">
                {{ '名称: ' + erform.c_point_name }}
              </div>
            </el-form-item>
            <el-form-item prop="area" label-width="10px">
              <div style="font-size: 22px">
                {{ '位置: ' + erform.c_point_addr }}
              </div>
            </el-form-item>
          </el-form>
          <el-form v-model="erform" v-else style="min-width: 55%">
            <el-form-item prop="area" label-width="10px" label="">
              <!-- <div slot="label" style="font-size:24px">编号:</div> -->
              <div style="font-size: 22px">
                {{ '编号: ' + erform.pointNum }}
              </div>
            </el-form-item>
            <el-form-item prop="area" label-width="10px">
              <!-- <div slot="label" style="font-size:24px">名称:</div> -->

              <div style="font-size: 22px">
                {{ '名称: ' + erform.pointName }}
              </div>
            </el-form-item>
            <el-form-item prop="area" label-width="10px">
              <div style="font-size: 22px">
                {{ '位置: ' + erform.pointAddr }}
              </div>
            </el-form-item>
          </el-form>
          <div class="ml10 mt20" style="width: 200px; height: 200px" id="qrcode" ref="qrcode"></div>
        </div>
      </div>

      <div class="center">
        <el-button type="primary" @click="doPrint('imageWrapper')" size="small">打印</el-button>
        <el-button type="success" size="small" @click="toImage('imageWrapper', '1')">下载</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import unitList from '@/components/unitList';

import { getCompanyList, switchCompany } from '../../api/company';
import html2canvas from 'html2canvas';
import QRCode from 'qrcodejs2';
export default {
  data() {
    return {
      list: [],
      tabList: this.$store.state.user.userInfo.isWenwu ? [{ name: '文物巡查', id: 1 }] : [{ name: '消防巡查', id: 0 }],

      cpNum: '',
      nowIndex: 0,
      params: {
        page: 1,
        c_point_name: '',
        c_point_addr: '',
        c_point_number: '',
        c_point_area: '',
        c_company_num: this.$store.state.user.company.cCompanyNum || '',

        c_point_area_id: '',
      },
      list1: [],
      total1: 0,
      params1: {
        companyNum: '',
        pageNum: 1,
        areaId: '',
        pageSize: 10,
      },
      imgUrl: '',
      areaList: [],
      erform: {},
      total: 0,
      showDia: false,
      showDia1: false,
      searchForm: this.$getForm('safePlace'),
      editData: {},
      remoteFuncs: {
        placeList: [], // 区域
        _this: this,
        getPlace(resolve) {
          var _this = this._this;
          _this.$post('/xuncha/selectxcname').then((res) => {
            resolve(res.data);
          });
        },
        getNumber(resolve) {
          var _this = this._this;
          _this.$post('/xuncha/selectxcnum').then((res) => {
            resolve(res.data);
          });
        },

        getUnit(resove) {
          var _this = this._this;
          _this.$post('/devicemanage/selectconpanybyme').then((res) => {
            resove(res.data);
          });
        },
      },
    };
  },
  created() {},
  components: { unitList },
  methods: {
    handleSizeChange(val) {
      this.params1.pageSize = val; //更新每页的条数
      this.getList(); //重新获取列表数据
    },
    handleCurrentChange() {
      this.params1.pageNum = val; //重新获取列表数据
      this.getList();
    },
    changeTab(index, it) {
      this.nowIndex = index;
      this.getDatas();
    },
    chooseArea(it) {
      this.params1.pageNum = 1;
      // console.log(this.params1.pageNum, '页数');
      // console.log(it);
      if (this.tabList[this.nowIndex].id == 0) {
        this.params.c_point_area_id = it.x_company_id;
        this.params.page = 1;
        this.getList();
      } else {
        this.params1.areaId = it.x_company_id;
        this.params.page = 1;
        this.getWWList();
      }
    },
    changeStatus(it, status) {
      console.log(status);
      var form = { c_point_uuid: it.c_point_uuid };
      var url = '';
      if (status == 1) {
        //启用
        url = '/patrol/patrolstop';
        form.c_states = 1;
      } else if (status == 2) {
        //删除
        url = '/patrol/patroldel';
      } else if (status == 0) {
        //停用
        url = '/patrol/patrolstop';
        form.c_states = 0;
      }
      console.log(form);
      console.log(url);
      this.$post(url, form).then((res) => {
        this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
        this.getList();
      });
      // var c_company_num = it.c_company_num;
    },

    changeStatus1(it, status) {
      console.log(status);
      var form = { id: it.id };
      var url = '';
      if (status == 1) {
        //启用
        url = '/inspection/wenwuInspectionPoint/switchInspection';
        form.states = 1;
        this.$post(url, form).then((res) => {
          this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
          this.getWWList();
        });
      } else if (status == 2) {
        //删除
        url = `/inspection/wenwuInspectionPoint/${it.id}`;
        this.$remove(url).then((res) => {
          this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
          this.getWWList();
        });
      } else if (status == 0) {
        //停用
        url = '/inspection/wenwuInspectionPoint/switchInspection';
        form.states = 0;

        this.$post(url, form).then((res) => {
          this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
          this.getWWList();
        });
      }
      console.log(form);
      console.log(url);

      // var c_company_num = it.c_company_num;
    },

    cancle() {
      this.resetSearch();
      this.getList();
    },
    //图片格式转换方法
    dataURLToBlob(dataurl) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    // 图片下载
    toImage(divText, imgText) {
      let canvasID = this.$refs[divText];
      let that = this;
      let a = document.createElement('a');
      html2canvas(canvasID).then((canvas) => {
        let dom = document.body.appendChild(canvas);
        dom.style.display = 'none';
        a.style.display = 'none';
        document.body.removeChild(dom);
        let blob = that.dataURLToBlob(dom.toDataURL('image/png'));
        a.setAttribute('href', URL.createObjectURL(blob));
        //这块是保存图片操作  可以设置保存的图片的信息
        a.setAttribute('download', imgText + '.png');
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(blob);
        document.body.removeChild(a);
      });
    },
    // 生成二维码
    qrcode(text) {
      let qrcode = new QRCode('qrcode', {
        width: 200,
        height: 200, // 高度
        text, // 二维码内容
        render: 'canvas', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',
        // foreground: '#ff0'
      });
    },

    //生成二维码详情modle
    makeerwei(it) {
      console.log(it);
      this.erform = it;
      this.showDia1 = true;
      setTimeout(() => {
        var obj = { key: it.c_point_number || it.pointNum, remark: it.remark };
        this.qrcode(JSON.stringify(obj));
      }, 100);
      console.log(it);
    },
    getDatas() {
      if (this.tabList[this.nowIndex].id == 0) {
        this.$post('/xuncha/xunchaareadetail', {
          c_company_num: this.cpNum,
        }).then((res) => {
          console.log(res);
          if (res.data.length) {
            this.areaList = res.data;
            var obj = { x_company_id: '', x_company_area: '全部点位' };
            this.areaList.unshift(obj);
            this.params.c_point_area_id = res.data[0].x_company_id;
            this.getList();
          } else {
            this.params.c_point_area_id = '';
            this.areaList = [];
            this.getList();
          }
        });
      } else {
        this.$post('/xuncha/xunchaareadetailWenWu', {
          c_company_num: this.cpNum,
        }).then((res) => {
          if (res.data.length) {
            this.areaList = res.data;

            this.params1.areaId = res.data[0].x_company_id;
            this.getWWList();
          } else {
            this.params1.areaId = '';
            this.areaList = [];
            this.getWWList();
          }
        });
      }
    },
    getList() {
      this.$post('/patrol/patrollist', this.params).then((res) => {
        this.list = res.data.list;
        this.total = res.data.count;
      });
    },
    getWWList() {
      this.$get('/inspection/wenwuInspectionPoint/list', this.params1).then((res) => {
        this.list1 = res.rows;
        this.total1 = res.count;
      });
    },
    pageChange(val) {
      this.params1.pageNum = 1;
      this.params1.pageSize = 10;
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          log(data);
          var obj = { ...this.params, ...data };
          this.params = obj;
          this.params.page = 1;
          this.getList();
          this.showDia = false;
          // this.resetSearch()
        })
        .catch((e) => {});
    },
    //  打印

    doPrint(divText) {
      console.log(divText);
      let subOutputRankPrint = document.getElementById(divText);
      console.log(subOutputRankPrint.innerHTML);
      let newContent = subOutputRankPrint.innerHTML;
      let oldContent = document.body.innerHTML;
      document.body.innerHTML = newContent;
      window.print();
      window.location.reload();
      document.body.innerHTML = oldContent;
      return false;
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = {
        ...this.params,

        c_point_name: '',
        c_point_number: '',
        c_point_addr: '',
        c_point_area: '',
      };
    },
    getOne(v) {
      this.cpNum = v;
    },
    getUnit(v) {
      this.cpNum = v;
    },
  },
  //   beforeRouteEnter(to, from, next) {

  //   next(vm => {
  //        if(from.name==='/safe/safe-addpoint'){
  //           vm.getList()
  //           }
  //     //因为当钩子执行前，组件实例还没被创建
  //     // vm 就是当前组件的实例相当于上面的 this，所以在 next 方法里你就可以把 vm 当 this 来用了。
  //     console.log(vm);//当前组件的实例
  //   });
  // },
  watch: {
    showDia1(val) {
      console.log(val);
      if (!val) {
        document.getElementById('qrcode').innerHTML = '';
      }
    },
    // nowIndex(){
    //   this.list = []

    //   this.getDatas()
    // },
    cpNum() {
      this.list = [];
      this.params.c_company_num = this.cpNum;
      this.params.page = 1;
      this.params1.companyNum = this.cpNum;
      this.params1.pageNum = 1;
      this.getDatas();
    },
  },
};
</script>

<style scoped>
.el-dialog .el-dialog__body {
  padding: 0 !important;
}
.mark {
  background: #3d62de;
  color: #fff;
}
.container-list {
  height: 100%;
}
.areaitem {
  height: 30px;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  border-bottom: 1px groove;
  margin-right: 20px;
  cursor: pointer;
}
.choose {
  border-radius: 10px;
  width: 20%;
  height: 550px;
  border: 1px solid #ccc;
}
</style>
